(function () {
  var API_URL = 'https://lipsel.com:3215/withdrawal/submit';

  function init() {
    var wrap = document.querySelector('.ls-withdrawal');
    if (!wrap || wrap._wdInit) return;
    wrap._wdInit = true;

    var form = wrap.querySelector('.ls-withdrawal__form');
    var review = wrap.querySelector('.ls-withdrawal__review');
    var success = wrap.querySelector('.ls-withdrawal__success');
    var error = wrap.querySelector('.ls-withdrawal__error');
    var confirmBtn = wrap.querySelector('[data-action="confirm"]');
    var backBtn = wrap.querySelector('[data-action="back"]');

    function field(name) { return form.querySelector('[name="' + name + '"]'); }

    // 1 žingsnis -> peržiūra. Ne form submit event — temos globalus handler
    // submit'ą nuryja (stopPropagation), todėl mygtukas type=button + click.
    function goReview() {
      if (!form.reportValidity()) return;
      error.hidden = true;

      ['name', 'order_number', 'email', 'comment'].forEach(function (k) {
        var el = wrap.querySelector('[data-summary="' + k + '"]');
        if (el) el.textContent = field(k).value.trim();
      });
      var comment = field('comment').value.trim();
      wrap.querySelector('[data-summary="comment"]').hidden = !comment;
      wrap.querySelector('[data-summary-comment-label]').hidden = !comment;

      form.hidden = true;
      review.hidden = false;
      review.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    var continueBtn = form.querySelector('.ls-withdrawal__btn');
    continueBtn.setAttribute('type', 'button');
    continueBtn.addEventListener('click', goReview);
    form.addEventListener('submit', function (e) { e.preventDefault(); goReview(); });

    backBtn.addEventListener('click', function () {
      review.hidden = true;
      form.hidden = false;
    });

    // 2 žingsnis: „Patvirtinti sutarties atsisakymą"
    confirmBtn.addEventListener('click', function () {
      confirmBtn.disabled = true;
      backBtn.disabled = true;
      error.hidden = true;

      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: field('name').value.trim(),
          order_number: field('order_number').value.trim(),
          email: field('email').value.trim(),
          comment: field('comment').value.trim(),
          website: field('website').value,
          shop_host: wrap.dataset.shopHost,
          locale: wrap.dataset.locale,
        }),
      })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
        .then(function (data) {
          wrap.querySelector('[data-result="reference"]').textContent = data.reference || '';
          wrap.querySelector('[data-result="submitted_at"]').textContent = data.submitted_at || '';
          review.hidden = true;
          success.hidden = false;
          success.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function () {
          error.hidden = false;
          confirmBtn.disabled = false;
          backBtn.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
